module.exports = __webpack_public_path__ + "img/police-officer.eeb9d690.gif";